import React from 'react'
import { Field, reduxForm } from 'redux-form'
import { renderTextField } from '../../Forms/fieldRenderers'
import { isNumeric } from '../../Forms/fieldValidators'
import { FORM_BODEGAS_BUQUES } from '../../../config/forms'

function CamposBodegaBuque () {
  return (
    <Field
      name='numeroBodega'
      type='text'
      label='Número de bodega'
      component={renderTextField}
      autoFocus={false}
      validate={[isNumeric]}
      placeholder=''
      maxLength={1}
    />
  )
}

const withReduxForm = reduxForm({
  form: FORM_BODEGAS_BUQUES,
  enableReinitialize: true
})

export default withReduxForm(CamposBodegaBuque)
